export default function Marquee({ items }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center gap-12 pr-12" aria-hidden={hidden || undefined}>
      {items.map((item) => (
        <span key={item} className="flex items-center gap-12 whitespace-nowrap">
          <span className="font-display text-sm font-bold uppercase tracking-[0.3em] text-white/55">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-aqua" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-midnight py-6"
      data-testid="marquee-strip"
    >
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-midnight to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-midnight to-transparent" />
    </div>
  );
}
